export const HOME_CONTACT_INFO = {
  label: "CONTACT US",
  title: "이용 안내",
  description: "교육 과정 및 수료 절차 관련 문의를 안내해드립니다",
  items: [
    {
      id: "phone",
      label: "Call",
      value: "(+82) 010-2952-1960",
      href: "tel:+821029521960",
    },
    {
      id: "email",
      label: "Email",
      value: "hopescience0110@naver.com",
      href: "mailto:hopescience0110@naver.com",
    },
    {
      id: "address",
      label: "Address",
      value: "서울특별시 성동구 상원6길 8, 비 1층 이72호(성수동1가)",
    },
  ],
};

export const HOME_CONTACT_FORM = {
  title: "상담문의",
  privacyLabel: "개인정보 수집 및 이용 동의(필수)",
  submitLabel: "문의하기",
  submittingLabel: "문의 접수 중...",
};
